(() => {
  const root=document.querySelector('[data-finder-context]');if(!root)return;
  try {
    const saved=JSON.parse(sessionStorage.getItem('jootti_finder_bridge_v2'));
    if(!saved||saved.handle!==root.dataset.productHandle||!/^\d+$/.test(saved.id))return;
    const target=new URL(saved.url,location.origin);
    const routing=window.JoottiFinderRouting;
    const dedicated=target.pathname==='/pages/find-your-rod';
    const legacy=target.pathname==='/pages/compare'&&target.searchParams.get('view')==='jootti-rod-finder';
    const draft=target.pathname==='/pages'&&target.searchParams.has('preview_key')&&routing&&routing.preview;
    if(target.origin!==location.origin||!(dedicated||legacy||draft)||!routing)return;
    root.querySelector('[data-finder-return]').href=routing.finder(target);
    root.querySelector('[data-finder-criteria]').textContent=saved.criteria;
    const copy=JSON.parse(root.querySelector('[data-finder-context-copy]').textContent);
    root.querySelector('[data-finder-compared]').textContent=Array.isArray(saved.names)&&saved.names.length?copy.compared+': '+saved.names.join(' · '):'';
    root.hidden=false;
  }catch(_){}
})();
